<div class='container-xs-height full-height'>
  <div class='row-xs-height'>
    <div class='col-xs-height col-middle'>
      <wait-progress [xo]="xo"></wait-progress>
    </div>
  </div>
</div>
